import { OdataFilters, queryCollection } from "helpers/reqparams";
import groupBy from "lodash/groupBy";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/logistTasks";
const defaultQuery = {
    orderBy: ["id desc"],
};

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...defaultQuery });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const getKanban = () => {
    return request(`${resource}/getKanban`, { method: "GET" }).then(
        (res) => ({ data: groupBy(res, "stage"), count: res.length }) as any,
    );
};
const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...defaultQuery });
    return request(`${resource}/getListExcel?${query}`, { method: "GET" }, { withoutMiddleware: true }).then((res) =>
        downloadFileHandler(res, "Задачи логистам.xlsx"),
    );
};
const getSettings = () => request(`${resource}/getSettings`, { method: "GET" });

const getStatistics = () => request(`${resource}/getStatistics`, { method: "GET" });

const applySettings = (params: {}) => alertRequest(`${resource}/applySettings`, body(params));

const getActiveCount = () => request(`${resource}/getActiveCount`, { method: "GET" });

const setAsViewed = (params: {}) => request(`${resource}/setAsViewed`, body(params));

const complete = (params: {}) => alertRequest(`${resource}/complete`, body(params));

const cancel = (params: {}) => alertRequest(`${resource}/cancel`, body(params));

const getItem = ({ id }: { id: number }) => request(`${resource}/get/${id}`, { method: "GET" });

export {
    index,
    getItem,
    getSettings,
    getStatistics,
    applySettings,
    getActiveCount,
    setAsViewed,
    complete,
    cancel,
    getListExcel,
    getKanban,
};
